export default {
  dateType: 1,
  dates: [new Date().toStringRu(), new Date().toStringRu()],
  SumFrom: 0,
  SumTo: 0,
  AvailableSumFrom: 0,
  AvailableSumTo: 0,
  CurrencyIds: [],
  ContragentId: '',
  ContragentName: '',
  ContragentSearchTypeId: '',
  Number: '',
  Type: '',
  OwnerUserId: '',
  OwnerUserCode: '',
  ParentNumber: '',
  OwnerLegalEntityId: '',
  IsUsed: false,
  IsPayed: false,
  loading: false,
  TypeSubsidies: 0,
}
